import type { MutationStopDraft } from './types';

const EXECUTED = new Set(['loaded', 'unloaded', 'completed', 'done', 'executed']);

export function isExecutedStop(stop: Pick<MutationStopDraft, 'actualAt' | 'status'>): boolean {
  if (stop.actualAt) return true;
  return EXECUTED.has(String(stop.status || '').toLowerCase());
}

export function splitStopsByExecution(stops: MutationStopDraft[]): {
  executed: MutationStopDraft[];
  future: MutationStopDraft[];
} {
  const sorted = [...stops].sort((a, b) => a.position - b.position);
  const executed: MutationStopDraft[] = [];
  const future: MutationStopDraft[] = [];
  for (const s of sorted) {
    if (isExecutedStop(s)) executed.push(s);
    else future.push(s);
  }
  return { executed, future };
}

export function stopLabel(stop: MutationStopDraft): string {
  const city = stop.city?.trim();
  const addr = stop.address?.trim();
  if (city && addr) return `${city}, ${addr}`;
  if (city) return city;
  if (addr) return addr;
  return stop.type === 'loading' ? 'Погрузка' : 'Выгрузка';
}

export function viewStopToDraft(raw: Record<string, unknown>, index: number): MutationStopDraft {
  return {
    uid: String(raw.executionStopUid ?? raw.id ?? `stop-${index}`),
    id: raw.id != null ? Number(raw.id) : null,
    type: String(raw.type || 'unloading').toLowerCase() === 'loading' ? 'loading' : 'unloading',
    position: Number(raw.position ?? index),
    pointType: (raw.pointType as string) ?? null,
    pointId: raw.pointId != null ? Number(raw.pointId) : null,
    parentLoadingStopId: raw.parentLoadingStopId != null ? Number(raw.parentLoadingStopId) : null,
    address: (raw.address as string) ?? null,
    city: (raw.city as string) ?? null,
    contactPerson: (raw.contactPerson as string) ?? null,
    phone: (raw.phone as string) ?? null,
    plannedAt: raw.plannedAt ? String(raw.plannedAt) : null,
    actualAt: raw.actualAt ? String(raw.actualAt) : null,
    notes: (raw.notes as string) ?? null,
    status: (raw.status as string) ?? null
  };
}

export function draftToSaveRow(stop: MutationStopDraft): Record<string, unknown> {
  return {
    id: stop.id ?? undefined,
    type: stop.type,
    position: stop.position,
    pointType: stop.pointType,
    pointId: stop.pointId,
    parentLoadingStopId: stop.parentLoadingStopId,
    address: stop.address,
    city: stop.city,
    contactPerson: stop.contactPerson,
    phone: stop.phone,
    plannedAt: stop.plannedAt,
    actualAt: stop.actualAt,
    notes: stop.notes,
    status: stop.status
  };
}

export function mergeStopsForSave(executed: MutationStopDraft[], future: MutationStopDraft[]): MutationStopDraft[] {
  const all = [...executed, ...future].map((s, idx) => ({ ...s, position: idx }));
  return all;
}

export function isLiveRouteStatus(status: string | null | undefined): boolean {
  const s = String(status || '').toUpperCase().replace(/\s+/g, '_');
  return ['IN_TRANSIT', 'DELIVERED', 'WAITING_LOADING'].includes(s);
}
